import React from 'react';
import createReactContext from '../context';
var context = createReactContext({});
var Provider = context.Provider;
export { Provider };

function filterProps(props, keys) {
  if (!props) return {};
  var value = {};
  keys.forEach(function (k) {
    value[k] = props[k];
  });
  return value;
}

export var consumer = function consumer(Origin) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, null, function (value) {
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, filterProps(value, keys)))
        );
      })
    );
  };
};